import { Icon, IconProps } from "./Icon";

export function IconCar(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M21.2 10h-3.76l-1.83-3.65A3.65 3.65 0 0 0 12.17 4H7.36A7.45 7.45 0 0 0 0 10.24V18h3.17A3 3 0 1 0 3 17H1v-6h20.2a1.81 1.81 0 0 1 1.8 1.8V17h-2v1h3v-5.2a2.81 2.81 0 0 0-2.8-2.8ZM6 15a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm8.7-8.25L16.32 10H8V5h4.18a2.69 2.69 0 0 1 2.52 1.75ZM7 5v5H1.08A6.41 6.41 0 0 1 7 5Zm3 7h2v1h-2zm7 2a3 3 0 0 0-3 3h-4v1h4.18A3 3 0 1 0 17 14Zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z" />
    </Icon>
  );
}
